import { render, staticRenderFns } from "./CertificadoView.vue?vue&type=template&id=207a5e84&scoped=true&"
import script from "./CertificadoView.vue?vue&type=script&lang=js&"
export * from "./CertificadoView.vue?vue&type=script&lang=js&"
import style0 from "./CertificadoView.vue?vue&type=style&index=0&id=207a5e84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207a5e84",
  null
  
)

export default component.exports